export default "__VITE_ASSET__DPITRWOY__"